/**
 * useCutoffHour Hook
 *
 * Returns the cutoff hour from the current brand context.
 * Used by inventory wizard and report pages to pre-fill date hours.
 *
 * @see US - Heure de coupure inventaires & rapports
 */

import { useAuth } from '@/context/AuthContext';

/** Default cutoff hour if brand data is not available */
const DEFAULT_CUTOFF_HOUR = 7;

/**
 * Returns the cutoff hour for the current brand.
 *
 * @returns number (0-23) representing the cutoff hour
 *
 * @example
 * const cutoffHour = useCutoffHour();
 * // Use to pre-fill date hours in reports
 * const start = new Date(now.getFullYear(), now.getMonth(), 1, cutoffHour, 0, 0, 0);
 */
export function useCutoffHour(): number {
  const { user } = useAuth();
  return user?.currentBrand?.cutoffHour ?? DEFAULT_CUTOFF_HOUR;
}
